import { useState } from 'react';

const useNavContext = () => {
  const [openItemId, setOpenItemId] = useState<string | null>(null);

  const openDropdown = (id: string) => {
    setOpenItemId(id);
  };

  const closeDropdown = () => {
    setOpenItemId(null);
  };

  return {
    openItemId,
    openDropdown,
    closeDropdown,
  };
};

export { useNavContext };
